export default __webpack_public_path__ + "static/media/fauna-funnel.a513fc50.png";